<template>
  <div class="page" :style="{height:'100%'}">
    <PhotoMakeHeader></PhotoMakeHeader>
    <div style="height: 10%"></div>
    <div class="tip">
      <img style="margin: 0 15px;width: 15px" src="../assets/make/uploadPhoto/tip-icon.png" />网页不提供照片存储功能，证件照自付款成功之日起7日后会自动删除，请尽早提取！

    </div>
    <div ref="dropBox" id="dropBox">
      <a class="upload">

        <span class="upload-txt-title">选择图片上传或直接拖入照片开始制作</span>
        <span class="upload-txt-tip">支持扩展名：.jpg .png .bmp</span>

        <div class="upload-btn-1">
          <div class="upload-btn-icon">
            <img style="width:45px;" src="../assets/make/uploadPhoto/icon_compute.png">
          </div>

          <div class="btn" style="">电脑上传图片</div>
          <input class="upload-input" @change="choose" type="file" accept="image/*">
        </div>
        <img src="../assets/make/uploadPhoto/split.png" class="upload-split" />
        <div @click="creatQrCode" class="upload-btn-2">
          <div class="upload-btn-icon">
            <img style="width: 45px;" src="../assets/make/uploadPhoto/icon_iphone.png">
          </div>
          <div class="btn" style="">手机上传图片</div>
        </div>
      </a>


    </div>
    <RightDialog :noMake="true"></RightDialog>
    <QRCodeDialog :invalid="QRCodeInvalidFlag" @refresh="refreshQRCode" @close="closeQRCodeShow" :show="QRCodeShow"></QRCodeDialog>
    <PhotoMakeFooter></PhotoMakeFooter>
  </div>




</template>

<script>

    import api from "../makeOnlineApi/api";
    import utils from "../makeOnlineApi/utils";
    import QRCode from "qrcodejs2";
    import axios from 'axios';
    import QRCodeDialog from "../components/QRCodeDialog";
    import PhotoMakeHeader from "../components/PhotoMakeHeader";
    import PhotoMakeFooter from "../components/PhotoMakeFooter";
    import RightDialog from '../components/RightDialog'
    // import SearchInput from "../components/SearchInput";
    const uploadImage = axios.create({
        timeout: 20000,
        headers: {'Content-Type': 'application/octet-stream'}
    });

    export default {
        name: "UploadPhoto",
        components: {QRCodeDialog,PhotoMakeHeader,PhotoMakeFooter,RightDialog},
        data() {
            return{
                qrcode:null,
                cid:'',
                QRCodeShow:false,
                QRCodeInvalidFlag:false,
                ws:null
            }
        },

        beforeCreate() {

            // this.$socket.open()

        },
        destroyed() {
            console.log('关闭')

        },
        created() {
            console.log(document.body.scrollWidth)
            console.log(document.body.scrollHeight)
            this.clearStore()
            if (!localStorage.getItem('user_key')){
                this.getUserKey()
            }else {
                this.getAppInfo()
            }


            // this.createWebSocket()

        },



        mounted() {
            const dropBox = this.$refs.dropBox
            dropBox.ondragenter = this.ignoreDrag;
            dropBox.ondragover = this.ignoreDrag;
            dropBox.ondrop = this.drop;

            console.log('offsetHeight',document.body.clientHeight)
            console.log('offsetWidth',document.body.offsetWidth)
            console.log('height', window.screen.height)
            console.log('width', window.screen.width)
            // this.sockets.subscribe('response_link_result',(date)=>{
            //     console.log('response_link_result',date)
            // })
            // this.$message({
            //     showClose: true,
            //     message: '这是一条消息提示'
            // });

            // this.creatQrCode()

        },
        // sockets:{
        //     //这里是监听connect事件
        //     connect: function(){
        //         // 获取每台客服端生成的id
        //         this.websocketid = this.$socket.id;
        //         console.log('链接服务器',this.websocketid);
        //     },
        //     // 监听断开连接，函数
        //     disconnect(){
        //         console.log('断开服务器连接');
        //
        //     },
        //
        //     pc_socket_link_result(data) {// 后端按主题名推送的消息数据
        //         console.log('Page：' + data)
        //     },
        //
        //     // 服务端指定有msg监听的客服端，可接对应发来的收消息，data服务端传的消息
        //     // msg(data){
        //     //     console.log('断开服务器连接');
        //     // }
        // },
        methods: {

            // 清除制作数据
            clearStore(){
                this.$store.dispatch('updateCurrentPhoto',[])// 清空制作数据
                this.$store.dispatch('updateSizeInfo',{}) // 清空制作数据
                this.$store.dispatch('updateOriginKey','')// 清空制作数据
                this.$store.dispatch('updateClothesId','-1') // 清空制作数据
                this.$store.dispatch('updateFairLevel',{})// 清空制作数据
                this.$store.dispatch('updateBgSelected','') // 清空制作数据
            },
            getUserKey() {
                api.getUserKey()
                    .then((res) => {
                        console.log('获得user_key', res.data)
                        localStorage.setItem('user_key',res.data.user_key)
                        this.getAppInfo()
                    })
            },
            getAppInfo(){
                api.getAppInfo()
                    .then((res)=>{
                        console.log('获得appInfo', res.data)
                        this.$store.dispatch("updateAppInfo", res.data)
                        // const appInfo = this.$store.getters.getAppInfo

                    })
            },

            createWebSocket(){
                let that=this
                if ("WebSocket" in window)
                {
                    console.log('cid',this.cid)
                    // 打开一个 web socket
                    this.ws = new WebSocket(`ws://api.id-photo-verify.com/ws/file/${this.cid}`);
                    this.ws.onopen = function()
                    {
                        console.log('Web Socket 已连接上')
                        that.ws.send(JSON.stringify([{'socket':'ok'}]));

                    };

                    this.ws.onmessage = function (evt)
                    {
                        const received_msg = JSON.parse(evt.data);
                        that.ws.close()
                        console.log('received_msg',received_msg)
                        that.QRCodeShow=false
                        that.$store.dispatch('updateOriginKey',received_msg.key)
                        that.makePhoto(received_msg.key)
                    };

                    this.ws.onclose = function()
                    {
                        // 关闭 websocket
                        console.log("连接已关闭...");
                        that.QRCodeInvalidFlag=true // 刷新 二维码失效标识

                    };
                }

                else
                {
                    // 浏览器不支持 WebSocket


                }
            },
            // 关闭二维码对话框
            closeQRCodeShow(e) {

                this.QRCodeShow = e
                this.ws.close()
            },
            // 刷新二维码
            refreshQRCode(){
                this.QRCodeInvalidFlag=false // 刷新 二维码失效标识
                this.cid=utils.uuid()
                this.qrcode.makeCode(`http://operation.id-photo-verify.com/apps/ZuiMeiWeb/UpLoadH5/index.html?cid=${this.cid}`)
                this.createWebSocket()
            },
            creatQrCode() {

                this.QRCodeShow=true
                if (!this.qrcode){
                    this.qrcode = new QRCode("qrcode", {
                        width: 116, // 二维码宽度，单位像
                        height: 116, // 二维码高度，单位像素
                    });

                    this.refreshQRCode()
                }



            },
            choose (e){
                let file = e.target.files[0]
                this.uploadImageToServer(file)
            },
             ignoreDrag(e) {
              //因为我们在处理拖放，所以应该确保没有其他元素会取得这个事件
              e.stopPropagation();
              e.preventDefault();
            },

            drop(e) {
                //取消事件传播及默认行为
              e.stopPropagation();
              e.preventDefault();
                //取得拖进来的文件
                const data = e.dataTransfer;
                const files = data.files;
                console.log('file',files)
                //将其传给真正的处理文件的函数
                this.uploadImageToServer(files[0]);
            },

            // 上传图片到服务器
            uploadImageToServer (file) {
                console.log('uploadImageToServer',file)
                let reader = new FileReader()
                reader.readAsArrayBuffer(file)
                let that = this
                reader.onload = function () {
                    api.getUploadAddress().then(res => {
                        let url = res.data.url
                        let key = res.data.key

                        uploadImage.put(url, this.result).then(res => {

                            if (res.status===200){
                                that.$store.dispatch('updateOriginKey',key)
                                that.makePhoto(key)
                            }

                        })
                    })
                }
            },

            // 制作图片
            makePhoto(key){
                console.log('到达制作图片')
                const loading = this.$loading({
                    lock: true,
                    text: '制作中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                // const sizeInfo=this.$store.state.sizeInfo
              let option={
                  key:key,
                  // spec_id:sizeInfo.spec_id,
                  fair_level:this.$store.state.appInfo.default_beauty_level,
                  list_clothes_id:['-1'],
                  need_resize:true,
                  // custom_params:sizeInfo.spec_id===-4?sizeInfo:{},
              }
              api.getCertificatePhotoTaskId(option).then((res)=>{
                  let taskId=res.data.task_id
                  let getPhotoByTaskId=(taskId)=>{
                      api.getPhotoByTaskId(taskId).then(res=>{
                          console.log('结果',res.data.result)
                          loading.close()
                          this.$store.dispatch('updateCurrentPhoto',res.data.result)
                          this.$store.dispatch('updateClothesId','-1')
                          this.$router.push({
                              path: '/preview',
                          })
                      }).catch(error=>{
                          if (error.code!==482){
                              loading.close()
                              //
                          }else {
                              setTimeout(()=>{
                                  getPhotoByTaskId(taskId)
                              },500)

                          }
                      })
                  }
                  getPhotoByTaskId(taskId)
              })
            }
        }
    }
</script>

<style scoped>
  .page{
    background-color: #FAFAFA;

  }

  .tip{
    width: 60%;
    height: 30px;
    display: flex;
    align-items: center;
    background-color: #FFFBE6;
    border: 1px solid #FFE58F;
    border-radius: 2px;
    margin:1% 0 1% 16%;
    font-size: 12px;
    color: #000000;
  }
  #dropBox{
    width: 60%;
    height: 70%;
    /*background-color: #d9d9d9*/
    margin:0 0 1% 16%;
    background-image: url("../assets/make/public/makeBg.png");
    background-size: 100% 100%;
  }
  .upload{
    width: 100%;
    height: 100%;
    display: flex;
    align-content: center;
    justify-content: center;
    /*cursor: pointer;*/
    position: relative;
    flex-wrap: wrap;
  }
  .upload-txt-title{
    width: 100%;
    position: relative;
    z-index: 1;
    color:#35315C;
    font-size: 20px;

    text-align: center;
  }
  .upload-txt-tip{
    width: 100%;
    position: relative;
    z-index: 1;
    color:#35315C;
    font-size: 10px;
    margin: 10px 0 40px 0;
    text-align: center;
  }
  .upload-btn-1{

    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

  }
  .upload-split{
    width: 2px;
    height: 23%;
    margin: 0 5%;

  }
  .upload-btn-2{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 10;
  }
  .upload-btn-icon{
    width: 100px;height:100px;margin-bottom:20px;display: flex;justify-content: center;align-items: center;background-color: #FFFFFF
  }
  .btn{
    background-color: #4B00A4;color:white;
    width: 140px;height: 30px;
    border-radius: 15px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
  }
  .upload-input{
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer;
    width: 100%;
    height: 100%;
    z-index: 9;
  }

</style>
